import React from 'react'

function BackgroundImage() {
  return (
    <div className="background-image-container">
      <h6> Ethiopia’s Marketplace for Buying, Selling & Renting Cars</h6>
    </div>
  )
}

export default BackgroundImage;